import React, { useEffect, useState } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { graphcms, QUERY_NEXT_EVENTS } from "../Graphql/Queries";
import { Link } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";

function NextEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    graphcms.request(QUERY_NEXT_EVENTS).then((res) => {
      setEvents(res.events);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="mt-28 mb-16 container mx-auto">
        <h2 className="text-2xl font-bold text-center mb-10">
          Upcoming Events
        </h2>
        <div className="flex justify-center gap-24 overflow-hidden py-10">
          {Array.from({ length: 3 }).map((_, i) => (
            <div
              key={i}
              className="card w-64 h-96 bg-slate-50 rounded-xl drop-shadow-xl overflow-hidden shrink-0">
              <Skeleton className="w-64 h-64 rounded-t-xl" />
              <div className="px-2 h-28 flex flex-col justify-center gap-y-2">
                <Skeleton className="h-4 w-3/4 mx-auto" />
                <Skeleton className="h-4 w-1/2 mx-auto" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="mt-28 mb-16 container mx-auto">
      <h2 className="text-2xl font-bold text-center mb-10">Upcoming Events</h2>
      <Splide
        options={{
          breakpoints: {
            640: {
              perPage: 1,
            },
            840: {
              perPage: 2,
            },
            1024: {
              perPage: 2,
            },
            1300: {
              perPage: 3,
            },
            1600: {
              perPage: 4,
            },
            1920: {
              perPage: 5,
            },
          },
          gap: "6rem",
          rewind: true,
          autoplay: true,
          pauseOnHover: false,
        }}>
        {events?.length === 0 ? (
          <h2 className="mx-auto text-base font-normal">
            There are no Upcoming Events
          </h2>
        ) : (
          events?.map((event) => {
            return (
              <SplideSlide className="h-[27rem]" key={event.id}>
                <Link to={`./event/${event.id}`}>
                  <div className="card w-64 h-[25rem] bg-slate-50 mx-auto rounded-xl drop-shadow-xl overflow-hidden">
                    <img
                      className=" rounded-t-xl w-64 h-64 object-cover"
                      src={event.flyerImage.url}
                      alt={event.caption}
                    />
                    <div className="px-2 h-32 flex flex-col gap-y-2 justify-center ">
                      <h4 className="w-full text-center text-base font-semibold">
                        {event.caption}
                      </h4>
                      <p className="text-center text-sm truncate">
                        {event.keywords}
                      </p>
                    </div>
                  </div>
                </Link>
              </SplideSlide>
            );
          })
        )}
      </Splide>
    </div>
  );
}

export default NextEvents;
